import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <div id="carousel" className="carousel slide" data-ride="carousel">
      <ol className="carousel-indicators">
        <li data-target="#carousel" data-slide-to="0" className="active"></li>
        <li data-target="#carousel" data-slide-to="1"></li>
        <li data-target="#carousel" data-slide-to="2"></li>
      </ol>

      <div className="carousel-inner">
        <div className="carousel-item active">
          <img src="/img/AdditionImages-1.jpeg" alt="Carousel Image" />
          <div className="carousel-caption">
            <p className="animated fadeInRight">We Are Professional</p>
            <h1 className="animated fadeInLeft" style={{ color: '#eed78c' }}>
              For Your Dream Projects
            </h1>
            <br /><br /><br /><br /><br /><br /><br /><br />
          </div>
        </div>

        <div className="carousel-item">
          <img src="/img/AdditionImages.jpeg" alt="Carousel Image" />
          <div className="carousel-caption">
            <p className="animated fadeInRight">Professional Contractors</p>
            <h1 className="animated fadeInLeft" style={{ color: '#eed78c' }}>
              Overseeing the entirety of Project Scope
            </h1>
            <br /><br /><br /><br /><br /><br /><br /><br />
          </div>
        </div>

        <div className="carousel-item">
          <img src="/img/FrontImage.jpeg" alt="Carousel Image" />
          <div className="carousel-caption">
            <p className="animated fadeInRight">We Are Trusted</p>
            <h1 className="animated fadeInLeft" style={{ color: '#eed78c' }}>
              For Your Engineering Initiatives
            </h1>
            <br /><br /><br /><br /><br /><br /><br /><br />
          </div>
        </div>
      </div>

      <a className="carousel-control-prev" href="#carousel" role="button" data-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
        <span className="sr-only">Previous</span>
      </a>
      <a className="carousel-control-next" href="#carousel" role="button" data-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true"></span>
        <span className="sr-only">Next</span>
      </a>
    </div>
  );
};

export default Hero;